import { Card, CardContent, Grid, Skeleton, Box, Typography } from '@mui/material';
import React from 'react';
import GNXTLogo from '../../../../assets/GatewayLogo/G_NXTLogo.png';

export const SkelltoneNewsDetails = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xl={8} md={8} lg={8}>
        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            height: '88vh',
            boxShadow: 'none',
            border: 1,
            borderColor: 'divider',
            borderRadius: '10px',
          }}
        >
          <Grid sx={{ display: 'flex', width: '100%', margin: '1rem', paddingRight: '10px' }}>
            <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
              <Grid container sx={{}}>
                <Skeleton variant="circular" width={30} height={30} sx={{ marginRight: '5px' }} />
                <Skeleton variant="text" width={100} />
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" sx={{ margin: '1rem' }}>
              <Grid item sx={{ float: 'right' }}>
                <Skeleton variant="text" width={120} />
              </Grid>
            </Grid>
          </Grid>
          <CardContent sx={{}}>
            <Skeleton variant="text" width="50%" height={30} />
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="rectangular" width={730} height={400} sx={{ margin: '1rem' }} />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="50%" />
            <Skeleton variant="text" width="70%" />
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="50%" />
            <Skeleton variant="text" width="70%" />
            <Skeleton variant="text" width="90%" />
          </CardContent>
        </Card>
      </Grid>

      <Grid item xl={4} md={4}>
        <Card
          sx={{
            display: 'flex',
            flexDirection: 'column',

            overflow: 'hidden',
            height: '88vh',
            boxShadow: 'none',
            borderRadius: '10px',
            border: 1,
            borderColor: 'divider',
          }}
        >
          <Grid sx={{ p: 2, position: 'sticky', borderBottom: 1, borderColor: 'divider' }}>
            <Skeleton variant="text" width="30%" height={30} />
          </Grid>
          <CardContent sx={{ overflow: 'auto', height: '76vh' }}>
            <Skeleton variant="text" width="90%" height={30} />
            <Skeleton variant="text" width="90%" height={30} />
            <Skeleton variant="text" width="90%" height={30} />
            <Skeleton variant="text" width="90%" height={30} />
          </CardContent>
          <Grid sx={{ backgroundColor: 'white', p: 2, borderTop: 1, borderColor: 'divider', position: 'sticky' }}>
            <Skeleton variant="text" width="70%" height={20} />
            <Skeleton variant="text" width="90%" height={20} />
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};
export const LoadingScreen = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '70vh',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(5px)',
      }}
    >
      <img src={GNXTLogo} style={{ height: 70, width: 150 }} alt="Logo" />
      <Typography sx={{ mt: 2 }}>Loading...</Typography>
    </Box>
  );
};

const RnRCardsSkeleton = () => {
  const cardSkeleton = (
    <Box sx={{ width: '100%', border: 1, borderColor: 'divider', borderRadius: '10px' }}>
      <Skeleton variant="rectangular" width={'100%'} height={'27vh'} />
    </Box>
  );

  return (
    <Box sx={{ background: 'white' }}>
      {Array.from({ length: 3 }).map((_, rowIndex) => (
        <Grid container wrap="nowrap" sx={{ display: 'flex', width: '74vw' }} key={rowIndex}>
          {Array.from({ length: 4 }).map((_, colIndex) => (
            <Grid
              item
              xs={12}
              md={12}
              key={colIndex}
              sx={{ width: '100%', my: 1, ml:1 }}
            >
              {cardSkeleton}
            </Grid>
          ))}
        </Grid>
      ))}
    </Box>
  );
};



export const ItemLoader = ({ style }) => (
  <Box>
    <Grid style={style} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Grid container wrap="nowrap" sx={{ display: 'flex' }}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box key={index} sx={{ width: '100%', marginRight: 3, my: 5 }}>
            <Skeleton variant="rectangular" width={'100%'} height={'27vh'} />
            <Box sx={{ pt: 0.5 }}>
              <Skeleton />
              <Skeleton width="60%" />
            </Box>
          </Box>
        ))}
      </Grid>
    </Grid>
  </Box>
);

export default RnRCardsSkeleton;
